import { useEffect, useState, type FormEvent } from 'react';
import { koreaDate } from '@chagok/domain';
import { thisMonth, thisYear, tryPeriod, type PeriodMode } from '../lib/period';
import { useApp } from '../state';

/** 대시보드·내역·반복 항목이 같은 기간을 쓴다. 기간은 양끝 포함. */
export function PeriodPanel() {
  const { period, setPeriod } = useApp();
  const [mode, setMode] = useState<PeriodMode>(period.mode);
  const [start, setStart] = useState(period.startInput);
  const [end, setEnd] = useState(period.endInput);
  const [message, setMessage] = useState<{ text: string; error: boolean }>({ text: '예: 2026년 2월~3월을 함께 조회할 수 있어요.', error: false });

  useEffect(() => {
    setMode(period.mode);
    setStart(period.startInput);
    setEnd(period.endInput);
  }, [period]);

  function changeMode(next: PeriodMode) {
    setMode(next);
    const s = next === 'year' ? period.start.slice(0, 4) : next === 'months' ? period.start.slice(0, 7) : period.start;
    const e = next === 'year' ? s : next === 'months' ? period.end.slice(0, 7) : period.end;
    setStart(s);
    setEnd(e);
  }

  function apply(event: FormEvent) {
    event.preventDefault();
    const result = tryPeriod(mode, start, mode === 'year' ? start : end);
    if (typeof result === 'string') setMessage({ text: result, error: true });
    else {
      setPeriod(result);
      setMessage({ text: '대시보드·내역·반복 항목에 같은 기간을 적용했습니다.', error: false });
    }
  }

  const today = koreaDate();
  const inputType = mode === 'year' ? 'number' : mode === 'months' ? 'month' : 'date';
  return (
    <form className="period-panel" onSubmit={apply}>
      <div className="period-top">
        <b>조회 기간</b>
        <div className="period-presets">
          <button type="button" onClick={() => setPeriod(thisMonth(today))}>
            이번 달
          </button>
          <button type="button" onClick={() => setPeriod(thisYear(today))}>
            올해 전체
          </button>
        </div>
      </div>
      <div className={`period-fields ${mode === 'year' ? 'three' : ''}`}>
        <label>
          조회 방식
          <select value={mode} onChange={(e) => changeMode(e.target.value as PeriodMode)}>
            <option value="months">월 범위</option>
            <option value="year">연도 전체</option>
            <option value="days">직접 날짜 지정</option>
          </select>
        </label>
        <label>
          {mode === 'year' ? '연도' : mode === 'months' ? '시작 월' : '시작일'}
          <input type={inputType} value={start} min={mode === 'year' ? 1900 : undefined} max={mode === 'year' ? 9998 : undefined} onChange={(e) => setStart(e.target.value)} required />
        </label>
        {mode !== 'year' && (
          <label>
            {mode === 'months' ? '종료 월' : '종료일'}
            <input type={inputType} value={end} onChange={(e) => setEnd(e.target.value)} required />
          </label>
        )}
        <button className="primary" type="submit">
          적용
        </button>
      </div>
      <p className={`hint ${message.error ? 'error' : ''}`} role="status">
        {message.text}
      </p>
    </form>
  );
}
